import { PencilIcon } from '@heroicons/react/24/outline'
import type { IUser } from '../../../Model/index.js'
import { TooltipTrigger } from '../../../Provider/TooltipManager.js'

const COLORS = ['badge-primary', 'badge-secondary', 'badge-accent', 'badge-success', 'badge-warning', 'badge-error', 'badge-info']

const hashStringToIndex = (str: string, arrayLength: number) => {
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash)
  }
  return Math.abs(hash) % arrayLength // Keep index within range
}

type ProjectParticipantBadgeProps = {
  user: IUser
  mayEdit: boolean
}

export const ProjectParticipantBadge = ({ user, mayEdit }: ProjectParticipantBadgeProps) => {
  const colorClass = COLORS[hashStringToIndex(user.email, COLORS.length)]
  return (
    <TooltipTrigger classNames={'relative'} tooltip={`${user.email} (${user.org.name})`}>
      <div className={`badge ${colorClass} badge-lg rounded-full text-white relative p-4`}>
        {user.email.charAt(0).toUpperCase()}
        {mayEdit && (
          <span className="absolute -bottom-1 -right-1 bg-gray-900 text-white p-1 rounded-full">
            <PencilIcon className="w-3 h-3" />
          </span>
        )}
      </div>
    </TooltipTrigger>
  )
}
